<template>
  <section class="completeSection" :class="{ isPc: !isSp }">
    <TitleText text="会員登録完了" />

    <TextGeneral v-if="prevPageType.isOrganic()" class="text">
      ご登録ありがとうございます。<br />ご登録いただいた情報はプロフィールからいつでも変更・確認が可能です。
      <template v-if="prevPageType.isCompare() || prevPageType.isCompareList()">
        <CompareOfferSp v-if="isSp" :compare-link="nextPageUrl" @click-go-compare="onClickGoCompare" />
        <CompareOfferPc v-else :compare-link="nextPageUrl" @click-go-compare="onClickGoCompare" />
      </template>
    </TextGeneral>
    <TextGeneral v-else class="text">
      会員登録が完了いたしました。<br />
      <template v-if="prevPageType.isShiryo()">引き続き資料請求の手続きをおこなってください。</template>
      <template v-else-if="prevPageType.isOc()">引き続きオープンキャンパス予約を進めてください。</template>
    </TextGeneral>

    <ButtonLink
      v-if="prevPageType.isReturnPage()"
      :button-url="returnPageUrl"
      button-text="見ていたページに戻る"
      button-color="colorPrimaryBorder"
      button-size="sizeLarge"
      class="gotoTopButton"
      @button-clicked="onClickReturnPage"
    />
    <ButtonLink
      v-if="prevPageType.isCompare() || prevPageType.isCompareList() || prevPageType.isReturnPage()"
      :button-url="isSp ? '/smp/' : '/'"
      button-text="スタディサプリ進路トップへ"
      :button-color="BUTTON_COLOR_LIST.SAPURI_WHITE"
      button-size="sizeMedium"
      class="gotoTopButton"
      @button-clicked="onClickGoTop"
    />
    <ButtonLink
      v-else-if="prevPageType.isOrganic()"
      :button-url="prevPageType.getUrlAfterCheckPrevPage(isSp)"
      button-text="スタディサプリ進路トップへ"
      button-color="colorPrimary"
      button-size="sizeLarge"
      class="gotoTopButton"
      @button-clicked="onClickGoTop"
    />
    <ButtonLink
      v-else-if="prevPageType.isShiryo() || prevPageType.isOc()"
      :button-url="prevPageType.getUrlAfterCheckPrevPage(isSp)"
      button-text="次へ進む"
      button-color="colorPrimary"
      button-size="sizeLarge"
      class="gotoNextButton"
      @button-clicked="onClickGoNext"
    />
    <ButtonLink
      v-if="prevPageType.isOrganic()"
      :button-url="`/${urlPrefix}/quipMember/account/myPage/`"
      button-text="プロフィールへ"
      :button-color="BUTTON_COLOR_LIST.SAPURI_WHITE"
      button-size="sizeMedium"
      class="gotoProfileButton"
      @button-clicked="onClickGoProfile"
    />
  </section>
</template>

<script>
import TitleText from './TitleText.vue';
import TextGeneral from './TextGeneral.vue';
import CompareOfferPc from './CompareOfferPc.vue';
import CompareOfferSp from './CompareOfferSp.vue';
import ButtonLink, { BUTTON_COLOR_LIST } from '../../../common/common/Button/ButtonLink.vue';
import { sendLog } from '../../../../helper/_sendLog';

export default {
  name: 'Complete',
  components: {
    TitleText,
    TextGeneral,
    ButtonLink,
    CompareOfferPc,
    CompareOfferSp,
  },
  props: {
    prevPageType: {
      type: Object,
      required: true,
    },
    isSpFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      nextPageUrl: '',
      returnPageUrl: '',
    };
  },
  computed: {
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
    BUTTON_COLOR_LIST() {
      return BUTTON_COLOR_LIST;
    },
    urlPrefix() {
      return this.$isSp ? 'smp2' : 'net2';
    },
  },
  created() {
    this.setCompareLink();
    this.setReturnPageLink();
  },
  methods: {
    /**
     * 比較選択画面 or 比較画面の場合、導線に対応する遷移先URLの設定を行う
     */
    setCompareLink() {
      if (!(this.prevPageType.isCompare() || this.prevPageType.isCompareList())) return;
      const gakkoCds = frontend.nextPageUrlParams;
      this.nextPageUrl = this.prevPageType.getUrlAfterCheckPrevPage(this.isSp, gakkoCds);
    },
    setReturnPageLink() {
      const vmReferrer = frontend.referrer;
      this.returnPageUrl = this.prevPageType.getUrlAfterCheckPrevPage(this.isSp, '', vmReferrer);
    },
    onClickGoProfile(event) {
      sendLog(s, event.target, `${trace_p}_profile`);
    },
    onClickGoNext(event) {
      sendLog(s, event.target, `${trace_p}_next`);
    },
    onClickGoCompare(event) {
      sendLog(s, event.target, `${trace_p}_compare`);
    },
    onClickGoTop(event) {
      sendLog(s, event.target, `${trace_p}_top`);
    },
    onClickReturnPage(event) {
      sendLog(s, event.target, `${trace_p}_prevPage`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.completeSection {
  padding: 32px 20px 40px;

  &.isPc {
    padding: 0;
  }

  .text {
    margin-bottom: 32px;
  }

  .gotoTopButton {
    margin-bottom: 16px;
  }
}
</style>
